import { Fragment, type ReactNode } from 'react';

/**
 * 검색어와 매칭된 첫 substring만 indigo <mark>로 강조한다 (대소문자 무시, trim된 query 기준).
 * - 리터럴 indexOf 매칭이라 정규식 escape 불필요.
 * - <mark>의 기본 노란 배경은 amber status와 충돌하므로 반드시 indigo로 리셋 (디자인 스펙 §1.4).
 * - query가 비었거나 매치가 없으면 원문을 그대로 반환.
 */
export function renderHighlighted(text: string, query: string): ReactNode {
  const needle = query.trim();
  if (!needle) return text;

  const idx = text.toLowerCase().indexOf(needle.toLowerCase());
  if (idx === -1) return text;

  const before = text.slice(0, idx);
  const match = text.slice(idx, idx + needle.length);
  const after = text.slice(idx + needle.length);

  return (
    <Fragment>
      {before}
      <mark className="rounded-[2px] bg-indigo-100 px-0.5 font-semibold text-indigo-900">{match}</mark>
      {after}
    </Fragment>
  );
}
